<template>
  <div>
    <b-form-group>
      <b-form-checkbox switch v-model="show_calendar" :disabled="disabled || busy">
        {{ trans('show_category_calendar_about') }}
      </b-form-checkbox>
    </b-form-group>
    <b-row v-if="show_calendar">
      <b-col>
        <b-form-group>
          <label>
            {{ trans('microsite_package_default_tab') }}
            <small class="text-muted" :title="trans('microsite_package_category_default_tab_about')" v-b-tooltip.hover>
              <i class="fa fa-fw fa-info-circle"></i>
            </small>
          </label>
          <b-form-radio-group v-model="default_tab" :disabled="disabled || busy">
            <b-form-radio  value="description">{{ trans('all_options') }}</b-form-radio>
            <b-form-radio  value="availability">{{ trans('calendar') }}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="trans('options_tab_label')">
          <b-form-input v-model="options_label" :placeholder="trans('all_options')" :disabled="disabled || busy" />
        </b-form-group>
      </b-col>
    </b-row>
    <label class="d-block">
      {{ trans('package_colors') }}
      <small class="text-muted" :title="trans('package_colors_about')" v-b-tooltip.hover>
        <i class="fa fa-fw fa-info-circle"></i>
      </small>
    </label>
    <b-row v-show="show_calendar && !loading">
      <b-col class="col-4" v-for="(pkg, index) in package_colors" :key="pkg.id">
        <b-form-group :label="pkg.name">
          <b-input :id="`package-color-${index}`" :value="pkg.color" :disabled="disabled || busy" />
        </b-form-group>
      </b-col>
    </b-row>
    <p v-if="show_calendar && loading">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </div>
</template>

<script>
  import 'spectrum-colorpicker/spectrum.js'

  export default {
    props: {
      organization: Object,
      package_category: Object,
      value: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        loading: false,
        error: null,
        show_calendar: this.value ? this.value.show_calendar : false,
        options_label: this.value ? (this.value.options_label || null) : null,
        default_tab: this.value ? this.value.default_tab : 'description',
        package_colors: this.value ? this.value.package_colors : [],
        packages: null,
      }
    },
    computed: {
      serialized() {
        return {
          show_calendar: this.show_calendar,
          options_label: this.options_label,
          default_tab: this.default_tab,
          package_colors: _.map(this.package_colors, pkg => {
            return {id: pkg.id, color: pkg.color}
          }),
        }
      },
    },
    watch: {
      show_calendar() {
        this.$emit('input', this.serialized)
      },
      default_tab() {
        this.$emit('input', this.serialized)
      },
      options_label() {
        this.$emit('input', this.serialized)
      }
    },
    methods: {
      onColorChange(index, color) {
        this.onColorMove(index, color)
        this.$emit('input', this.serialized)
        console.log('onColorChange', index, this.package_colors[index].color)
      },
      onColorMove(index, color) {
        if (color._a == 0) this.package_colors[index].color = this.organization.button_color
        else this.package_colors[index].color = color.toHexString()
      },
      renderColors() {
        let palette = _.uniq(_.compact(_.map(this.package_colors, 'color')))
        _.each(this.package_colors, (pkg, index) => {
          $('#package-color-' + index).spectrum({
            preferredFormat: "hex",
            showInput: true,
            cancelText: trans('cancel'),
            chooseText: trans('choose'),
            allowEmpty: false,
            showInitial: true,
            clickoutFiresChange: true,
            hideAfterPaletteSelect: true,
            showButtons: false,
            showPalette: true,
            palette: palette,
            change: _.partial(this.onColorChange, index),
            move: _.partial(this.onColorMove, index),
          })
        })
      },
      loadPackages() {
        if (!this.package_category || !this.package_category.id) {
          this.packages = []
          return
        }
        this.error = null
        this.busy = true
        this.loading = true
        let url = `/organization/${this.organization.id}/package/list?category_id=${this.package_category.id}&per_page=100`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.loading = false
          this.packages = response.data.data
          this.package_colors = _.map(this.packages, pkg => {
            let o = _.find(this.package_colors || [], {id: pkg.id}) || {
              id: pkg.id,
              color: this.organization.button_color
            }
            o.name = pkg.name
            return o
          })
          this.$nextTick(this.renderColors)
        })
        .catch(error => {
          this.busy = false
          this.loading = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.categoryCalendar = this
      this.loadPackages()
    }
  }
</script>